import api from './api';

const taxFormsService = {
  // Get all tax forms and generated 1099s for an agent
  getAgentTaxForms: async (agentId) => {
    const response = await api.get(`/tax-forms/agent/${agentId}`);
    return response.data.data || response.data; // Handle both response structures
  },

  // Get all submitted tax forms (W-9/W-8BEN) for current user's agency
  getAll: async (type = null) => {
    const params = type ? { type } : {};
    const response = await api.get('/tax-forms', { params });
    return response.data.data || response.data; // Handle both response structures
  },

  // Get all generated 1099s for agency (admin only)
  getGenerated1099s: async () => {
    const response = await api.get('/tax-forms/1099s');
    return response.data.data || response.data;
  },

  // Get specific submitted tax form
  getTaxForm: async (formId) => {
    const response = await api.get(`/tax-forms/${formId}`);
    return response.data.data || response.data;
  },

  // Submit W-9 form
  submitW9: async (formData) => {
    const payload = {
      form_type: 'W-9',
      form_data: formData,
      digital_signature: formData.digitalSignature || formData.signature
    };
    const response = await api.post('/tax-forms', payload);
    return response.data;
  },

  // Submit W-8BEN form
  submitW8BEN: async (formData) => {
    const payload = {
      form_type: 'W-8BEN',
      form_data: formData,
      digital_signature: formData.digitalSignature || formData.signature
    };
    const response = await api.post('/tax-forms', payload);
    return response.data;
  },

  // Generate 1099 data (for preview before saving)
  generate1099: async (agentId, year) => {
    const response = await api.post(`/tax-forms/generate-1099/${agentId}`, { tax_year: year });
    return response.data;
  },

  // Save 1099 form as permanent record
  save1099: async (agentId, taxYear, totalCommission, w9Data) => {
    const response = await api.post(`/tax-forms/save-1099/${agentId}`, { 
      tax_year: taxYear, 
      total_amount: totalCommission,
      w9_data: w9Data 
    });
    return response.data;
  },

  // Legacy methods for backward compatibility (deprecated)
  uploadTaxForm: async (agentId, formData) => {
    console.warn('uploadTaxForm is deprecated. Use submitW9 or submitW8BEN instead.');
    const response = await api.post(`/tax-forms/agent/${agentId}/upload`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    return response.data;
  },

  downloadTaxForm: async (formId) => {
    console.warn('downloadTaxForm is deprecated. PDF generation not yet implemented.');
    const response = await api.get(`/tax-forms/${formId}/download`, {
      responseType: 'blob'
    });
    return response;
  },

  // Download form (alias for backward compatibility)
  download: async (formId) => {
    return taxFormsService.downloadTaxForm(formId);
  }
};

export default taxFormsService;
